import {
  SOCKET_EVENT_NAMES,
  AI_IMAGES_SOCKET_SERVICE_NAME
} from '@/blocks/Auth/definitions'

import useHandleAIUpdatedSocketMessage from './useHandleAIUpdatedSocketMessage'

const useHandleSocketMessage = () => {
  const {
    updateImageHandler,
    refetchAIImagesStatusHandler
  } = useHandleAIUpdatedSocketMessage()

  const socketEventHandlers = {
    [AI_IMAGES_SOCKET_SERVICE_NAME]: {
      [SOCKET_EVENT_NAMES[AI_IMAGES_SOCKET_SERVICE_NAME].RESULT_PUBLISHED]: refetchAIImagesStatusHandler,
      [SOCKET_EVENT_NAMES[AI_IMAGES_SOCKET_SERVICE_NAME].IMAGE_VALIDATIONS_READY]: updateImageHandler
    }
  }

  return socketEventHandlers
}

export default useHandleSocketMessage
